import {
  Box,
  Input,
  Text,
  VStack,
  HStack,
  IconButton,
  Spinner,
  useToast,
} from '@chakra-ui/react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { getWANumber } from '../../../hooks/whatsapp';
import { patchWhatsAppNumber } from '../../../hooks/whatsapp_number';

export default function EditBusinessNamePage() {
  const navigate = useNavigate();
  const { orgId, whatsappNumberId } = useParams();
  const toast = useToast();
  const [businessName, setBusinessName] = useState('');
  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      if (!orgId || !whatsappNumberId) {
        setLoading(false);
        return;
      }
      const response = await getWANumber(orgId);
      const waNumber = response?.success
        ? response.data?.find((item: { id: string }) => String(item.id) === String(whatsappNumberId))
        : null;
      if (waNumber) {
        setBusinessName(waNumber.display_name || waNumber.business_name || '');
      }
      setLoading(false);
    })();
  }, [orgId, whatsappNumberId]);

  const handleSave = async () => {
    if (!orgId || !whatsappNumberId || !businessName.trim()) {
      return;
    }

    setSaving(true);
    const response = await patchWhatsAppNumber(whatsappNumberId, orgId, {
      business_name: businessName.trim(),
      display_name: businessName.trim(),
    });
    setSaving(false);

    if (response.success) {
      toast({
        title: 'Business name updated',
        status: 'success',
        duration: 2000,
        isClosable: true,
      });
      navigate(-1);
      return;
    }

    toast({
      title: 'Unable to update business name',
      status: 'error',
      duration: 3000,
      isClosable: true,
    });
  };

  return (
    <Box bg="white" minH="100vh">
      <HStack px={4} py={3} justify="space-between">
        <IconButton
          aria-label="Back"
          icon={<ArrowLeft />}
          variant="ghost"
          onClick={() => navigate(-1)}
        />
        <Text fontWeight="semibold">Business name</Text>
        {saving ? (
          <Spinner size="sm" />
        ) : (
          <Text color="green.600" fontWeight="medium" cursor="pointer" onClick={handleSave}>
            Save
          </Text>
        )}
      </HStack>

      <VStack px={4} mt={6} spacing={3} align="stretch">
        {loading ? (
          <Spinner alignSelf="center" />
        ) : (
          <>
            <Input
              value={businessName}
              onChange={(event) => setBusinessName(event.target.value)}
              placeholder="Business name"
              fontSize="lg"
              variant="flushed"
              autoFocus
            />
            <Text fontSize="xs" color="gray.500">
              This is the name customers will see on WhatsApp.
            </Text>
          </>
        )}
      </VStack>
    </Box>
  );
}
